import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FormFavorecido = ({ fechaModal, favorecido_id}) => {
  //valores iniciais do formulario
  const inicialForm = {
    favorecido_id: favorecido_id,
    favorecido: '',
    favorecido_documento: ''
  }

  const [form, onChange, setForm] = useForm(inicialForm)
  const [loading, setLoading]     = useState(true)

  //preenche setform e formulario
  const editFavorecido = (favorecido_id) => {
    const url = rotas.favorecido+favorecido_id
    const retorno = rest.get(url)
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista !== '') {
        setForm(ret.lista[0])
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if(favorecido_id != ''){
      editFavorecido(favorecido_id)
    }else{
      setForm(inicialForm)
      setLoading(false)
    }
  },[])

  const excluir = () => {
    if(favorecido_id != ''){

      formSwal.queue([{
        title:                'Deseja excluir o favorecido ?',
        confirmButtonText:    'SIM',
        showCancelButton:     true,
        text:                 'Essas informações serão excluidas do banco',
        showLoaderOnConfirm:  true,
        cancelButtonColor:    '#d33',
        preConfirm: () => {
          // setLoading(true)
          const param = {'favorecido_id': favorecido_id}
          const url = rotas.favorecido+favorecido_id
          try{
            const retorno = rest.del(url, param)
            retorno.then(ret => {
              if (ret.success && ret.success == 'S') {
                formSwal.fire('Salvo!', ret.msg, 'success')
                fechaModal()
              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })
            return (true)
          }catch(err){
            console.log(err)
            formSwal.fire('Erro!',err,'error')
          }
        }
      }])
    }
  }

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault();

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.favorecido+'gravar.php'
        if(favorecido_id !== ''){
          return rest.post(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editFavorecido(favorecido_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
          })
        }else{
          return rest.put(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editFavorecido(ret.retorno.insert_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
          })
        }
      }

    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <>
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md='2'>
                <FormGroup>
                  <Label for="favorecido_id">Código</Label>
                  <Input
                    disabled
                    style     = {{background: '#F9F9F9'}}
                    name        = "favorecido_id"
                    id          = "favorecido_id"
                    value       = {form.favorecido_id}
                    onChange    = {onChange('favorecido_id')}
                  />
                </FormGroup>
              </Col>

              <Col md='6'>
                <FormGroup>
                  <Label for="favorecido">Favorecido</Label>
                  <Input
                    required
                    id          = "favorecido"
                    name        = "favorecido"
                    placeholder = "Informe o nome do favorecido"
                    maxLength   = {35}
                    value       = {form.favorecido}
                    onChange    = {onChange('favorecido')}
                  />
                </FormGroup>
              </Col>

              <Col md='2'>
                <FormGroup>
                  <Label for="documento">Documento</Label>
                  <Input
                    id          = "documento"
                    name        = "documento"
                    maxLength   = {14}
                    value       = {form.favorecido_documento}
                    onChange    = {onChange('favorecido_documento')}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="danger" size="md" onClick={() => excluir()}>Excluir</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
      </>
    )
  }

}

export default FormFavorecido
